export default __webpack_public_path__ + "static/media/full_face_not_smiling.3223747b.svg";